import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';

import { EditCompetitorService } from '../../edit-competitor/edit-competitor.service';
import { Race } from 'src/app/models/race';
import { RaceClass } from 'src/app/models/race-class';
import { ClassProgress, InfoLapModalData, Lap } from 'src/app/models';
import { ProgressService } from 'src/app/services/progress.service';
import { RaceProgressRegistration } from 'src/app/models/race_progress_registration';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-progress-table',
  templateUrl: './progress-table.component.html',
  styleUrls: ['./progress-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressTableComponent implements OnInit {
  @Input() scrollableCols: any[] = [];
  @Input() sections!: number;
  @Input() i!: number;
  @Input() TVResume!: boolean;
  @Input() selectedLang!: string;
  @Input() selectedRace!: Race;
  @Input() selectedClass!: RaceClass;
  @Input() modeEdit!: boolean;
  @Input() checkHeight!: boolean;
  @Input() time_state!: number;
  @Input() classes: Array<ClassProgress> = [];
  @Input() minimize: boolean = false;

  @Output() refresh: EventEmitter<RaceClass> = new EventEmitter();
  @Output() openInfoEvent: EventEmitter<string> = new EventEmitter();

  infoClassModal = false;
  infoClassModalData!: ClassProgress;
  @ViewChildren('turboTable') turboTables!: QueryList<Table>;

  infoLapModal = false;
  infoLapModalData!: InfoLapModalData;
  editLapModal = false;

  constructor(
    public progressService: ProgressService,
    public appSettings: SettingsService,
    private editCompetitorService: EditCompetitorService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
  }

  test(e: any) {
    console.log(e);
  }

  clickInfo(cUid: string) {
    this.openInfoEvent.emit(cUid);
  }

  clickLap(lap: Lap, indexLap, competitor: RaceProgressRegistration) {
    if (this.modeEdit) {
      this.editCompetitor(competitor);
    } else {
      this.showInfoLap(lap, indexLap, competitor);
    }
  }

  showInfoLap(lap: Lap, indexLap: number, competitor: RaceProgressRegistration) {
    if (lap && lap.penalty.length) {
      this.infoLapModal = true;
      this.infoLapModalData = new InfoLapModalData(lap, indexLap, competitor);
    } else {
      this.messageService.clear();
      this.messageService.add({
        severity: 'info',
        summary: this.appSettings.translate[this.appSettings.selectedLang]['nopenalty'],
      });
    }
  }

  async save() {
    const promises: Promise<Object | undefined | void>[] = [];
    this.infoLapModalData.lapNew.marks.forEach((mark) => {
      if (mark.delete) {
        promises.push(    this.progressService.deleteMark(mark, this.selectedRace, this.selectedClass, this.infoLapModalData.competitor));
      } else {
        const markOld = this.infoLapModalData.lap.marks.find((item) => item.uid === mark.uid);
        if (markOld) {
          const timeOld = markOld.time ? markOld.time.getTime() : null;
          const timeNew = mark.time ? mark.time.getTime() : null;
          if (timeOld !== timeNew) {
            if (markOld.time) {
              promises.push(    this.progressService.deleteMark(markOld, this.selectedRace, this.selectedClass, this.infoLapModalData.competitor));
            }
            promises.push(    this.progressService.saveMark(mark.marshal, mark.time ? mark.time.getTime() : null, this.selectedRace.rUid, this.selectedClass.clUid, this.infoLapModalData.competitor.registration.user.cUid));
          }
        } else {
          console.error('not found mark old ;(', mark);
        }
      }
    });
    await Promise.all(promises);
    // this.editLapModal = false;
    this.refresh.emit();
  }

  editCompetitor(competitor: RaceProgressRegistration) {
    if (!this.modeEdit) return;
    const dialogRef = this.editCompetitorService.openEditCompetitor(this.selectedRace, this.selectedClass, competitor);
    dialogRef?.onClose.subscribe((refresh) => {
      if (refresh) {
        this.refresh.emit();
      }
    });
  }

  showInfoClass(classProgres: ClassProgress) {
    this.infoClassModalData = classProgres;
    this.infoClassModal = true;
    return false;
  }

  width(e): string {
    if (!e.width) {
      e.width = '50px';
    }
    return e.width;
  }

  private createClassProgressSlice(source: ClassProgress, start: number, end: number): ClassProgress {
    return new ClassProgress({
      bestLapUid: source.bestLapUid,
      class: source.class,
      registrations: source.registrations.slice(start, end),
      marks: source.marks,
    } as any);
  }

  getValues(classes: Array<ClassProgress>, sections: number, i: number): ClassProgress[] {
    if (classes.length) {
      const source = classes[0];
      const size = Math.ceil(source.registrations.length / sections);
      return [this.createClassProgressSlice(source, size * i, size * i + size)];
    }
    return [];
  }
}
